module.exports = __webpack_public_path__ + "static/media/stripe-onboarding_3.4eae78e9.png";